import mutations from '@/store/hoPaginatedList/mutations';

export default mutations;
